(function () {
"use strict";
function safe(fn, label) {
return function () {
try {
return fn.apply(this, arguments);
} catch (err) {
try {
(window.__sv7Errors = window.__sv7Errors || []).push({
t: Date.now(),
l: label || "anonymous",
m: (err && err.message) || String(err),
});
if (window.console && console.error) console.error("[sv7:" + (label || "?") + "]", err);
} catch (_) {  }
}
};
}
var $  = function (sel, root) { return (root || document).querySelector(sel); };
var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
var actions = Object.create(null);
function action(name, fn) { actions[name] = safe(fn, "action:" + name); }
document.addEventListener("click", safe(function (e) {
var el = e.target;
while (el && el !== document && el.getAttribute) {
var a = el.getAttribute("data-sv7-action");
if (a && actions[a]) { actions[a](el, e); return; }
el = el.parentNode;
}
}, "delegated-click"));
function raf(fn) {
var ticking = false;
return function () {
if (ticking) return;
ticking = true;
var args = arguments, ctx = this;
requestAnimationFrame(function () {
ticking = false;
try { fn.apply(ctx, args); } catch (err) {
(window.__sv7Errors = window.__sv7Errors || []).push({ t: Date.now(), l: "raf", m: err.message || "" });
}
});
};
}
var Toast = (function () {
var host, queue = [], running = false;
function ensureHost() {
host = host || document.getElementById("sv7-toast");
return host;
}
function drain() {
if (running || !queue.length) return;
var h = ensureHost(); if (!h) return;
running = true;
var item = queue.shift();
h.textContent = item.msg;
h.hidden = false;
h.setAttribute("data-variant", item.variant || "info");
setTimeout(safe(function () {
h.hidden = true;
h.removeAttribute("data-variant");
running = false;
drain();
}, "toast-hide"), item.ms || 2400);
}
return {
show: function (msg, opts) {
opts = opts || {};
queue.push({ msg: String(msg || ""), variant: opts.variant, ms: opts.ms });
drain();
},
};
})();
var Cart = (function () {
var state = { count: 0, items: [], total: 0, fetching: false };
var listeners = [];
var refreshPromise = null, refreshAgain = false, mutationVersion = 0;
var mutationTail = Promise.resolve(), pendingMutations = 0;
function mutate(url, body) {
var run = mutationTail.then(function () {
pendingMutations++; mutationVersion++;
return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || "Cart update failed"); return data; }); })
.then(function (data) { pendingMutations--; mutationVersion++; return data; }, function (err) { pendingMutations--; mutationVersion++; throw err; });
});
mutationTail = run.catch(function () {});
return run;
}
function emit(eventKind) {
for (var i = 0; i < listeners.length; i++) {
try { listeners[i](state); } catch (err) {
(window.__sv7Errors = window.__sv7Errors || []).push({ t: Date.now(), l: "cart-emit", m: err.message || "" });
}
}
try {
var kind = eventKind || "updated";
var detail = { count: state.count, total: state.total, items: state.items };
document.dispatchEvent(new CustomEvent("sv7:cart:" + kind, { detail: detail, bubbles: true }));
document.dispatchEvent(new CustomEvent("cart:" + kind, { detail: detail, bubbles: true }));
if (kind === "added") {
document.dispatchEvent(new CustomEvent("cart:item-added", { detail: detail, bubbles: true }));
}
} catch (_) { }
}
function renderBubble() {
$$("[data-sv7-cart-count]").forEach(function (el) {
el.textContent = state.count > 0 ? String(state.count) : "";
el.hidden = state.count === 0;
});
}
function refresh() {
if (pendingMutations) return mutationTail.then(refresh);
if (refreshPromise) { refreshAgain = true; return refreshPromise; }
state.fetching = true;
var version = mutationVersion;
refreshPromise = fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
.then(function (r) { if (!r.ok) throw new Error("Could not refresh cart"); return r.json(); })
.then(function (data) {
if (version !== mutationVersion || pendingMutations) { refreshAgain = true; return; }
applyCartJson(data);
})
.then(function () {
refreshPromise = null; state.fetching = false;
if (refreshAgain) { refreshAgain = false; return refresh(); }
return state;
}, function (err) { refreshPromise = null; state.fetching = false; refreshAgain = false; try { (window.__sv7Errors = window.__sv7Errors || []).push({t: Date.now(), l: "cart-refresh", m: err.message || String(err)}); } catch (_) {} return state; });
return refreshPromise;
}
function add(variantId, qty, props) {
var body = { id: Number(variantId), quantity: qty || 1 };
if (props) body.properties = props;
return mutate("/cart/add.js", body).then(function (item) {
try {
if (!(props && props._free_gift) && typeof window.sv7Track === "function") {
window.sv7Track("AddToCart", {
content_ids: [String(item.product_id || "")],
content_name: item.product_title || item.title || "",
content_type: "product",
currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "INR",
value: ((item.final_price != null ? item.final_price : item.price) || 0) * (qty || 1) / 100,
quantity: qty || 1,
is_free_gift: false,
variant_id: String(item.variant_id || variantId || ""),
});
}
} catch (_) {  }
try {
var merged = state.items.slice();
var found = -1;
for (var i = 0; i < merged.length; i++) {
if (merged[i] && String(merged[i].key) === String(item.key)) { found = i; break; }
}
if (found >= 0) merged[found] = item; else merged.push(item);
var totalQty = 0;
var totalPrice = 0;
for (var j = 0; j < merged.length; j++) {
totalQty += (merged[j].quantity | 0);
totalPrice += (merged[j].final_line_price != null ? merged[j].final_line_price : (merged[j].line_price | 0));
}
state.items = merged;
state.count = totalQty;
state.total = totalPrice;
renderBubble();
emit("added");
} catch (_) {  }
return refresh().then(function () { return item; });
});
}
function applyCartJson(data) {
if (data && typeof data.item_count !== "undefined") {
state.count = data.item_count | 0;
state.items = data.items || [];
state.total = data.total_price | 0;
state.total_discount = data.total_discount || 0;
state.currency = data.currency || "INR";
renderBubble();
emit();
return state;
}
return refresh();
}
function update(key, qty) {
var body = { updates: {} }; body.updates[key] = qty | 0;
return mutate("/cart/update.js", body).then(applyCartJson);
}
function change(key, qty) {
return mutate("/cart/change.js", { id: key, quantity: qty | 0 }).then(applyCartJson);
}
function addItems(items) {
return mutate("/cart/add.js", { items: items }).then(refresh);
}
return {
refresh: refresh,
add: add,
update: update,
change: change,
addItems: addItems,
get: function () { return state; },
onChange: function (fn) { listeners.push(fn); },
};
})();
var Wishlist = (function () {
var KEY = "sv7:wishlist";
var MAX = 200;
function read() {
try {
var raw = JSON.parse(localStorage.getItem(KEY) || "[]");
if (!Array.isArray(raw)) return [];
return raw.filter(function (x) {
return typeof x === "string" && x.length > 0 && !/^\d+$/.test(x);
});
} catch (_) { return []; }
}
function write(list) {
try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {  }
}
function has(handle) { return read().indexOf(String(handle)) !== -1; }
function toggle(handle) {
handle = String(handle);
var list = read();
var i = list.indexOf(handle);
if (i === -1) {
list.push(handle);
if (list.length > MAX) list = list.slice(list.length - MAX);
} else {
list.splice(i, 1);
}
write(list);
updateBadge();
return i === -1;
}
function count() { return read().length; }
function updateBadge() {
var c = count();
$$("[data-sv7-wishlist-count]").forEach(function (el) {
el.textContent = c > 0 ? String(c) : "";
el.hidden = c === 0;
});
}
function paint() {
var list = read();
$$("[data-sv7-wishlist-handle]").forEach(function (btn) {
var handle = btn.getAttribute("data-sv7-wishlist-handle");
var active = list.indexOf(handle) !== -1;
btn.setAttribute("aria-pressed", active ? "true" : "false");
btn.classList.toggle("sv7-is-wishlisted", active);
});
updateBadge();
}
if (document.readyState !== "loading") {
setTimeout(paint, 0);
} else {
document.addEventListener("DOMContentLoaded", safe(paint, "wishlist-paint"));
}
return { read: read, has: has, toggle: toggle, count: count, paint: paint, updateBadge: updateBadge };
})();
action("share-product", function (btn, e) {
if (e && typeof e.preventDefault === "function") try { e.preventDefault(); } catch (_) {  }
var url   = btn.getAttribute("data-sv7-share-url") || window.location.href;
var title = btn.getAttribute("data-sv7-share-title") || document.title;
var text  = btn.getAttribute("data-sv7-share-text") || "";
btn.classList.remove("sv7-pulse");
btn.offsetWidth;
btn.classList.add("sv7-pulse");
if (navigator.share) {
navigator.share({ url: url, title: title, text: text })
.then(function () {
try {
if (typeof window.sv7Track === "function") {
window.sv7Track("Share", { content_type: "product", content_url: url });
}
} catch (_) {  }
})
.catch(function () {  });
return;
}
if (navigator.clipboard && navigator.clipboard.writeText) {
navigator.clipboard.writeText(url).then(function () {
Toast.show("Link copied", { variant: "success" });
}).catch(function () {
Toast.show("Couldn't copy — tap and hold to share", { variant: "info" });
});
return;
}
Toast.show("Couldn't open share sheet", { variant: "info" });
});
action("wishlist-toggle", function (btn) {
var handle = btn.getAttribute("data-sv7-wishlist-handle");
var id     = btn.getAttribute("data-sv7-wishlist-id");
if (!handle) return;
var added = Wishlist.toggle(handle);
$$('[data-sv7-wishlist-handle="' + handle + '"]').forEach(function (el) {
el.setAttribute("aria-pressed", added ? "true" : "false");
el.classList.toggle("sv7-is-wishlisted", added);
});
btn.classList.remove("sv7-pulse");
btn.offsetWidth;
btn.classList.add("sv7-pulse");
Toast.show(added ? "Saved to wishlist" : "Removed from wishlist");
try {
if (added && typeof window.sv7Track === "function") {
window.sv7Track("AddToWishlist", {
content_ids: id ? [String(id)] : [],
content_type: "product",
content_name: btn.getAttribute("data-sv7-product-title") || "",
});
}
} catch (_) {  }
});
action("atc", function (btn) {
var variantId = btn.getAttribute("data-variant-id");
var qty = Number(btn.getAttribute("data-qty") || 1);
if (!variantId) return;
btn.setAttribute("aria-busy", "true");
btn.disabled = true;
Cart.add(variantId, qty).then(safe(function () {
btn.removeAttribute("aria-busy");
btn.disabled = false;
Toast.show("Added to cart", { variant: "success" });
var drawer = document.getElementById("sv7-cart-drawer");
if (drawer && drawer.open === false && typeof drawer.showModal === "function") {
try { drawer.showModal(); } catch (_) {  }
fireCartViewed("atc-auto-open");
}
}, "atc-success")).catch(safe(function () {
btn.removeAttribute("aria-busy");
btn.disabled = false;
Toast.show("Couldn't add — try again", { variant: "error" });
}, "atc-fail"));
});
var dialogFocusReturn = Object.create(null);
function openDialog(id) {
var el = document.getElementById(id);
if (!el) return;
try {
var active = document.activeElement;
if (active && active !== document.body) dialogFocusReturn[id] = active;
} catch (_) {  }
if (typeof el.showModal === "function") {
try { el.showModal(); if (id === "sv7-cart-drawer") fireCartViewed("dialog-open"); else if (id === "sv7-search") { var si = el.querySelector("[data-sv7-search-input]"); if (si) { try { si.focus({ preventScroll: true }); } catch (_) { try { si.focus(); } catch (_) {} } } } return; } catch (_) {  }
}
el.hidden = false;
el.setAttribute("aria-hidden", "false");
if (id === "sv7-cart-drawer") fireCartViewed("dialog-open-fallback");
}
var __sv7CartViewedLastFiredAt = 0;
function fireCartViewed(reason) {
try {
var now = Date.now();
if (now - __sv7CartViewedLastFiredAt < 5000) return;
__sv7CartViewedLastFiredAt = now;
if (typeof window.sv7Track !== "function") return;
var s = (Cart && typeof Cart.get === "function") ? Cart.get() : null;
if (!s || !s.count || s.count <= 0) return;
var items = Array.isArray(s.items) ? s.items : [];
var variantIds = items.map(function (it) { return it && it.variant_id != null ? String(it.variant_id) : null; }).filter(Boolean);
var productIds = items.map(function (it) { return it && it.product_id != null ? String(it.product_id) : null; }).filter(Boolean);
window.sv7Track("CartViewed", {
cartItemCount: s.count | 0,
cartTotal: (s.total | 0) / 100,
cartItemIds: variantIds,
cartProductIds: productIds,
currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "INR",
open_reason: reason || "unknown"
});
} catch (_) {  }
}
function closeDialog(id) {
var el = document.getElementById(id);
if (!el) return;
if (typeof el.close === "function") {
try { el.close(); } catch (_) {  }
} else {
el.hidden = true;
el.setAttribute("aria-hidden", "true");
}
try {
var ret = dialogFocusReturn[id];
if (ret && typeof ret.focus === "function" && document.contains(ret)) ret.focus();
} catch (_) {  }
dialogFocusReturn[id] = null;
}
action("open", function (btn, e) {
if (e && btn && btn.tagName === "A") { try { e.preventDefault(); } catch (_) {} }
var id = btn.getAttribute("data-sv7-target"); if (id) openDialog(id);
});
action("close", function (btn) {
var id = btn.getAttribute("data-sv7-target");
if (id) { closeDialog(id); return; }
var p = btn.parentNode;
while (p && p !== document) {
if (p.getAttribute && p.getAttribute("data-sv7-dialog")) { closeDialog(p.id); return; }
p = p.parentNode;
}
});
document.addEventListener("click", safe(function (e) {
var t = e.target;
if (!t || t.tagName !== "DIALOG") return;
if (!t.hasAttribute("data-sv7-dialog")) return;
if (!t.open && !t.hasAttribute("open")) return;
var rect = t.getBoundingClientRect();
var x = e.clientX, y = e.clientY;
if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) return;
closeDialog(t.id);
}));
var cardGalleryStates = typeof WeakMap === "function" ? new WeakMap() : null;
function cardGalleryState(media) {
var state = cardGalleryStates ? cardGalleryStates.get(media) : media.__sv7GalleryState;
if (!state) {
var index = Number(media.getAttribute("data-sv7-gallery-index") || 0);
state = { index: index, target: index, request: 0, suppressClick: false, suppressTimer: 0, pointer: null };
if (cardGalleryStates) cardGalleryStates.set(media, state);
else media.__sv7GalleryState = state;
}
return state;
}
function cardGalleryItems(media) {
var count = Math.min(3, Number(media.getAttribute("data-sv7-gallery-count") || 0));
var items = [];
for (var i = 0; i < count; i++) {
var src = media.getAttribute("data-sv7-gallery-" + i + "-src");
if (!src) continue;
items.push({
src: src,
srcset: media.getAttribute("data-sv7-gallery-" + i + "-srcset") || "",
alt: media.getAttribute("data-sv7-gallery-" + i + "-alt") || "",
});
}
return items;
}
function cardGalleryDots(media, index) {
$$('[data-sv7-gallery-dots] i', media).forEach(function (dot, i) {
dot.classList.toggle("is-active", i === index);
});
}
function showCardGalleryIndex(card, wantedIndex, commit) {
var media = card && card.querySelector("[data-sv7-card-gallery]");
if (!media) return false;
var items = cardGalleryItems(media);
if (items.length < 2 || wantedIndex < 0 || wantedIndex >= items.length) return false;
var image = media.querySelector("[data-sv7-card-image]");
if (!image) return false;
var state = cardGalleryState(media);
var item = items[wantedIndex];
var request = ++state.request;
state.target = wantedIndex;
var apply = function () {
if (request !== state.request) return;
image.setAttribute("src", item.src);
if (item.srcset) image.setAttribute("srcset", item.srcset);
else image.removeAttribute("srcset");
if (item.alt) image.setAttribute("alt", item.alt);
if (commit) {
state.index = wantedIndex;
state.target = wantedIndex;
media.setAttribute("data-sv7-gallery-index", String(wantedIndex));
cardGalleryDots(media, wantedIndex);
}
};
if (image.getAttribute("src") === item.src) apply();
else {
var loader = new Image();
loader.onload = apply;
loader.onerror = function () { if (request === state.request) state.target = state.index; };
loader.src = item.src;
}
return true;
}
function resetCardGallery(card, imageUrl, srcset, alt) {
var media = card && card.querySelector("[data-sv7-card-gallery]");
if (!media) return;
var state = cardGalleryState(media);
++state.request;
state.index = 0;
state.target = 0;
media.setAttribute("data-sv7-gallery-index", "0");
if (imageUrl) media.setAttribute("data-sv7-gallery-0-src", imageUrl);
if (srcset) media.setAttribute("data-sv7-gallery-0-srcset", srcset);
else media.removeAttribute("data-sv7-gallery-0-srcset");
if (alt) media.setAttribute("data-sv7-gallery-0-alt", alt);
cardGalleryDots(media, 0);
}
document.addEventListener("click", safe(function (e) {
var button = e.target && e.target.closest && e.target.closest("[data-sv7-gallery-prev],[data-sv7-gallery-next]");
if (!button) return;
e.preventDefault();
e.stopPropagation();
var card = button.closest("[data-sv7-card]");
var media = card && card.querySelector("[data-sv7-card-gallery]");
if (!media) return;
var state = cardGalleryState(media);
showCardGalleryIndex(card, state.index + (button.hasAttribute("data-sv7-gallery-next") ? 1 : -1), true);
}, "product-card-gallery-arrow"));
document.addEventListener("pointerdown", safe(function (e) {
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (!media || e.isPrimary === false || (typeof e.button === "number" && e.button !== 0)) return;
if (e.target.closest && e.target.closest("[data-sv7-gallery-prev],[data-sv7-gallery-next]")) return;
cardGalleryState(media).pointer = { id: e.pointerId, x: e.clientX, y: e.clientY };
}, "product-card-gallery-pointer-down"), { passive: true });
document.addEventListener("pointerup", safe(function (e) {
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (!media) return;
var state = cardGalleryState(media);
var start = state.pointer;
state.pointer = null;
if (!start || start.id !== e.pointerId) return;
var dx = e.clientX - start.x;
var dy = e.clientY - start.y;
if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy)) return;
var card = media.closest("[data-sv7-card]");
if (cardGalleryItems(media).length > 1) {
state.suppressClick = true;
clearTimeout(state.suppressTimer);
state.suppressTimer = setTimeout(function () { state.suppressClick = false; }, 450);
}
showCardGalleryIndex(card, state.index + (dx < 0 ? 1 : -1), true);
}, "product-card-gallery-pointer-up"), { passive: true });
document.addEventListener("pointercancel", safe(function (e) {
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (media) cardGalleryState(media).pointer = null;
}, "product-card-gallery-pointer-cancel"), { passive: true });
document.addEventListener("click", safe(function (e) {
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (!media) return;
var state = cardGalleryState(media);
if (!state.suppressClick) return;
state.suppressClick = false;
clearTimeout(state.suppressTimer);
e.preventDefault();
e.stopPropagation();
}, "product-card-gallery-suppress-link"), true);
document.addEventListener("pointerover", safe(function (e) {
if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
var card = media.closest("[data-sv7-card]");
if (cardGalleryItems(media).length > 1) showCardGalleryIndex(card, 1, false);
}, "product-card-gallery-hover-in"));
document.addEventListener("pointerout", safe(function (e) {
if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
var media = e.target && e.target.closest && e.target.closest("[data-sv7-card-gallery]");
if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
var state = cardGalleryState(media);
showCardGalleryIndex(media.closest("[data-sv7-card]"), state.index, false);
}, "product-card-gallery-hover-out"));
var hydrators = Object.create(null);
document.addEventListener("click", safe(function (e) {
var swatch = e.target && e.target.closest && e.target.closest("[data-sv7-card-swatch]");
if (!swatch) return;
e.preventDefault();
var card = swatch.closest("[data-sv7-card]");
if (!card) return;
$$('[data-sv7-card-swatch]', card).forEach(function (item) {
var selected = item === swatch;
item.setAttribute("aria-pressed", selected ? "true" : "false");
});
var imageUrl = swatch.getAttribute("data-image-url");
var image = card.querySelector("[data-sv7-card-image]");
if (imageUrl && image) {
image.setAttribute("src", imageUrl);
var srcset = swatch.getAttribute("data-image-srcset");
if (srcset) image.setAttribute("srcset", srcset);
else image.removeAttribute("srcset");
var alt = swatch.getAttribute("data-image-alt");
if (alt) image.setAttribute("alt", alt);
resetCardGallery(card, imageUrl, srcset, alt);
}
var variantId = swatch.getAttribute("data-variant-id");
if (variantId) {
$$('[data-sv7-card-product-link]', card).forEach(function (link) {
try {
var url = new URL(link.getAttribute("href") || "", window.location.href);
url.searchParams.set("variant", variantId);
link.setAttribute("href", url.pathname + url.search + url.hash);
} catch (_) { }
});
var directAdd = card.querySelector('[data-sv7-action="atc"]:not([data-sv7-variant-picker-add])');
if (directAdd) {
directAdd.setAttribute("data-variant-id", variantId);
directAdd.disabled = swatch.getAttribute("data-variant-available") === "false";
}
}
var position = swatch.getAttribute("data-option-position");
var value = swatch.getAttribute("data-option-value");
var picker = card.querySelector('[data-sv7-variant-picker]');
if (picker && position && value) {
try {
picker.dispatchEvent(new CustomEvent("sv7:picker-option", { bubbles: true, detail: { position: Number(position), value: value } }));
} catch (_) { }
}
}, "product-card-colour-swatch"));
document.addEventListener("click", safe(function (e) {
var sw = e.target && e.target.closest && e.target.closest(".sv7-card__sw");
if (!sw) return;
e.preventDefault();
var card = sw.closest(".sv7-card");
if (!card) return;
var raw = card.getAttribute("data-sv7-variant-map");
if (!raw) return;
var mapping;
try { mapping = JSON.parse(raw); } catch (_) { mapping = {}; }
var key = sw.getAttribute("data-sv7-swatch");
var lcKey = key && key.toLowerCase && key.toLowerCase();
var imgUrl = mapping[key] || mapping[lcKey];
$$(".sv7-card__sw", card).forEach(function (s) { s.classList.remove("is-active"); });
sw.classList.add("is-active");
var vidRaw = card.getAttribute("data-sv7-variant-id-map");
var vid = null;
if (vidRaw) {
try { var vidMap = JSON.parse(vidRaw); vid = vidMap[key] || vidMap[lcKey] || null; } catch (_) { vid = null; }
}
var productUrl = card.getAttribute("data-sv7-product-url") || "";
if (vid && productUrl) {
var hrefBase = productUrl.split("?")[0];
var newHref = hrefBase + "?variant=" + encodeURIComponent(vid);
var lnks = card.querySelectorAll("a.sv7-card__link, .sv7-card__n a");
for (var i = 0; i < lnks.length; i++) { lnks[i].setAttribute("href", newHref); }
}
if (!imgUrl) return;
var primary = card.querySelector(".sv7-card__img-primary");
if (primary) {
primary.setAttribute("src", imgUrl);
primary.removeAttribute("srcset");
var alt = card.querySelector(".sv7-card__img-alt");
if (alt) alt.style.display = "none";
}
}, "card-swatch-click"));
function registerHydrator(name, fn) { hydrators[name] = safe(fn, "hydrate:" + name); }
if ("IntersectionObserver" in window) {
var io = new IntersectionObserver(safe(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
var el = entry.target;
var name = el.getAttribute("data-sv7-lazy");
if (name && hydrators[name]) {
hydrators[name](el);
el.removeAttribute("data-sv7-lazy");
io.unobserve(el);
}
});
}, "io-callback"), { rootMargin: "200px 0px", threshold: 0.01 });
function scanLazy() {
$$("[data-sv7-lazy]").forEach(function (el) { io.observe(el); });
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", safe(scanLazy, "scan-on-ready"));
} else {
scanLazy();
}
document.addEventListener("shopify:section:load", safe(scanLazy, "scan-on-section-load"));
} else {
document.addEventListener("DOMContentLoaded", safe(function () {
$$("[data-sv7-lazy]").forEach(function (el) {
var name = el.getAttribute("data-sv7-lazy");
if (name && hydrators[name]) hydrators[name](el);
});
}, "no-io-fallback"));
}
var header = null;
function onScroll() {
if (!header) header = document.querySelector(".sv7-header");
if (!header) return;
header.classList.toggle("sv7-header--scrolled", window.scrollY > 8);
}
window.addEventListener("scroll", safe(raf(onScroll), "scroll"), { passive: true });
document.addEventListener("submit", safe(function (e) {
var form = e.target;
if (!form || form.tagName !== "FORM") return;
var action = (form.getAttribute("action") || "").toLowerCase();
if (action.indexOf("/cart") === 0) {
var clicked = form.querySelector('button[name="checkout"]:focus, button[name="checkout"]:active') || form.querySelector('button[name="checkout"]');
if (!clicked) return;
try {
if (typeof window.sv7Track === "function") {
var s = Cart.get();
window.sv7Track("InitiateCheckout", {
content_ids: (s.items || []).map(function (i) { return String(i.product_id || ""); }),
num_items: s.count || 0,
value: (s.total || 0) / 100,
currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "INR",
});
}
} catch (_) {  }
return;
}
if (form.getAttribute("data-sv7-search-form") !== null || form.matches('[data-sv7-search-form]')) {
var input = form.querySelector('[data-sv7-search-input]') || form.querySelector('input[type="search"]');
var q = input ? String(input.value || "").trim() : "";
if (!q) return;
try {
if (typeof window.sv7Track === "function") {
window.sv7Track("Search", { search_string: q });
}
} catch (_) {  }
}
}, "form-submit"), true);
registerHydrator("bundle-mega", function (root) {
var delay = Number(root.getAttribute("data-sv7-bundle-fallback-delay") || 3000);
setTimeout(safe(function () {
var fallback = root.querySelector("[data-sv7-bundle-fallback]");
if (!fallback) return;
if (root.contains(fallback)) {
root.setAttribute("data-sv7-bundle-hydrated", "fallback");
} else {
root.setAttribute("data-sv7-bundle-hydrated", "bundler");
}
}, "bundle-fallback-check"), delay);
});
/* Judge.me hydrator removed May 18 2026 — own review system canonical (see snippets/sv7-reviews-widget.liquid). */
window.sv7 = {
safe: safe,
toast: Toast.show,
cart: Cart,
wishlist: Wishlist,
openDialog: openDialog,
closeDialog: closeDialog,
action: action,
registerHydrator: registerHydrator,
};
document.addEventListener("DOMContentLoaded", safe(function () {
Wishlist.paint();
Cart.refresh();
onScroll();
}, "init"));
})();
(function(){
if (window.__sv7BisInit) return;
window.__sv7BisInit = true;
var ENDPOINT = 'https://engage.sinderella.in/webhooks/back-in-stock';
function setStatus(form, msg, kind) {
var el = form.querySelector('[data-sv7-bis-status]');
if (!el) return;
el.textContent = msg || '';
el.classList.remove('sv7-dialog__status--ok', 'sv7-dialog__status--err');
if (kind === 'ok')  el.classList.add('sv7-dialog__status--ok');
if (kind === 'err') el.classList.add('sv7-dialog__status--err');
}
function normalisePhone(raw) {
var digits = String(raw || '').replace(/\D/g, '');
if (digits.length < 10 || digits.length > 15) return null;
if (digits.length === 10) digits = '91' + digits;
return digits;
}
document.addEventListener('submit', function(ev) {
var form = ev.target;
if (!form || !form.matches || !form.matches('[data-sv7-bis-form]')) return;
ev.preventDefault();
var btn = form.querySelector('[data-sv7-bis-submit]');
var input = form.querySelector('input[name="phone"]');
if (!input) return;
var phone = normalisePhone(input.value);
if (!phone) {
setStatus(form, 'Enter a valid WhatsApp number (10 digits)', 'err');
input.focus();
return;
}
var payload = {
phone: phone,
shopifyProductId: form.getAttribute('data-sv7-bis-product-id') || '',
productTitle:     form.getAttribute('data-sv7-bis-product-title') || '',
productUrl:       form.getAttribute('data-sv7-bis-product-url') || '',
productImage:     form.getAttribute('data-sv7-bis-product-image') || ''
};
if (!payload.shopifyProductId) {
setStatus(form, 'Something went wrong. Please refresh and try again.', 'err');
return;
}
if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
setStatus(form, '', null);
fetch(ENDPOINT, {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify(payload)
})
.then(function(res) {
if (!res.ok) throw new Error('HTTP ' + res.status);
return res.json();
})
.then(function(data) {
if (data && (data.status === 'ok' || data.subscribed)) {
setStatus(form, 'Done — we\u2019ll WhatsApp you the second it\u2019s back.', 'ok');
input.value = '';
var dialogId = form.getAttribute('data-sv7-bis-dialog-id');
if (dialogId) {
setTimeout(function() {
var dlg = document.getElementById(dialogId);
if (dlg && typeof dlg.close === 'function') { try { dlg.close(); } catch (_) {} }
}, 2200);
}
} else {
throw new Error('unexpected response');
}
})
.catch(function(err) {
console.error('[sv7-bis] submit failed:', err);
setStatus(form, 'Couldn\u2019t save right now. Try again in a moment.', 'err');
})
.finally(function() {
if (btn) { btn.disabled = false; btn.textContent = 'Notify me on WhatsApp'; }
});
});
})();
(function(){ try {
if (window.__sv7CartIosFixInit) return;
var drawer = document.getElementById('sv7-cart-drawer');
if (!drawer || !('MutationObserver' in window)) return;
window.__sv7CartIosFixInit = true;
var bodyEl = drawer.querySelector('.sv7-drawer__body');
if (bodyEl && !bodyEl.hasAttribute('tabindex')) bodyEl.setAttribute('tabindex', '-1');
function apply(){
var isOpen = drawer.hasAttribute('open');
document.body.classList.toggle('sv7-cart-open', isOpen);
var siblings = document.body.children;
for (var i = 0; i < siblings.length; i++) {
var s = siblings[i];
if (s === drawer) { s.removeAttribute('inert'); continue; }
if (isOpen) s.setAttribute('inert', ''); else s.removeAttribute('inert');
}
if (isOpen && bodyEl) {
try { bodyEl.focus({ preventScroll: true }); } catch(_){}
}
}
apply();
new MutationObserver(apply).observe(drawer, { attributes: true, attributeFilter: ['open'] });
drawer.addEventListener('close', function () {
requestAnimationFrame(function () {
if (!drawer.hasAttribute('open')) apply();
});
});
} catch(e) { try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'cart-ios-fix',m:(e&&e.message)||String(e)});}catch(_){} } })();
(function(){ try {
if (window.__sv7CartHydrated) return;
window.__sv7CartHydrated = true;
function init(){ try {
var drawer = document.getElementById('sv7-cart-drawer');
if (!drawer || !window.sv7 || !window.sv7.cart) return;
var tier1 = parseInt(drawer.getAttribute('data-sv7-tier1-paise'), 10) || 129900;
var tier2 = parseInt(drawer.getAttribute('data-sv7-tier2-paise'), 10) || 149900;
var tier3 = parseInt(drawer.getAttribute('data-sv7-tier3-paise'), 10) || 199900;
var shippingThreshold = parseInt(drawer.getAttribute('data-sv7-shipping-threshold-paise'), 10) || 100000;
var tier1Label = drawer.getAttribute('data-sv7-tier1-label') || 'Khwaab';
var tier2Label = drawer.getAttribute('data-sv7-tier2-label') || 'Khwaab + Vaada';
var tier3Label = drawer.getAttribute('data-sv7-tier3-label') || 'Morni';
var tier1Variant = (drawer.getAttribute('data-sv7-tier1-variant') || '').trim();
var tier2Variant = (drawer.getAttribute('data-sv7-tier2-variant') || '').trim();
var tier3Variant = (drawer.getAttribute('data-sv7-tier3-red-variant') || '').trim();
var giftsDisabled = drawer.getAttribute('data-sv7-gifts-disabled') === '1'; // Jul 3 2026 — master free-gift kill switch (settings.disable_all_gifts): evicts any auto-added gift line, suppresses all gift auto-add, hides the rewards ladder.
var elItems = drawer.querySelector('[data-sv7-drawer-items]');
var elEmpty = drawer.querySelector('[data-sv7-drawer-empty]');
var elFooter = drawer.querySelector('[data-sv7-drawer-footer]');
var elSubtotal = drawer.querySelector('[data-sv7-drawer-subtotal]');
var elCount = drawer.querySelector('[data-sv7-drawer-count]');
var elToast = drawer.querySelector('[data-sv7-drawer-toast]');
var elSavings = drawer.querySelector('[data-sv7-drawer-savings]');
var elSavingsAmt = drawer.querySelector('[data-sv7-drawer-savings-amt]');
var elRewardsStatus = drawer.querySelector('[data-sv7-drawer-rewards-status]');
var elRewardsFill = drawer.querySelector('[data-sv7-drawer-rewards-fill]');
var elNode1 = drawer.querySelector('[data-sv7-drawer-rewards-node="1"]');
var elNode2 = drawer.querySelector('[data-sv7-drawer-rewards-node="2"]');
var elNode3 = drawer.querySelector('[data-sv7-drawer-rewards-node="3"]');
var elRewards = drawer.querySelector('[data-sv7-drawer-rewards]');
var elMobileRewardsSlot = drawer.querySelector('[data-sv7-drawer-mobile-rewards-slot]');
var rewardsHome = elRewards ? elRewards.parentNode : null;
var rewardsHomeNext = elRewards ? elRewards.nextSibling : null;
var mobileCartMedia = window.matchMedia ? window.matchMedia('(max-width: 700px)') : null;
function syncMobileRewardsPlacement() {
  if (!elRewards || !rewardsHome) return;
  if (mobileCartMedia && mobileCartMedia.matches && elMobileRewardsSlot) {
    if (elRewards.parentNode !== elMobileRewardsSlot) elMobileRewardsSlot.appendChild(elRewards);
    return;
  }
  if (elRewards.parentNode !== rewardsHome) rewardsHome.insertBefore(elRewards, rewardsHomeNext);
}
syncMobileRewardsPlacement();
if (mobileCartMedia) {
  if (mobileCartMedia.addEventListener) mobileCartMedia.addEventListener('change', syncMobileRewardsPlacement);
  else if (mobileCartMedia.addListener) mobileCartMedia.addListener(syncMobileRewardsPlacement);
}
var elShippingTier = drawer.querySelector('[data-sv7-drawer-shipping-tier]');
var elShippingCopy = drawer.querySelector('[data-sv7-drawer-shipping-copy]');
var elShippingProgress = drawer.querySelector('[data-sv7-drawer-shipping-progress]');
var elShippingFill = drawer.querySelector('[data-sv7-drawer-shipping-fill]');
var elNudge = drawer.querySelector('[data-sv7-drawer-nudge]');
var elOfferStatus = drawer.querySelector('[data-sv7-drawer-offer-status]');
var elUpsell = drawer.querySelector('[data-sv7-drawer-upsell]');
var elUpsellScroll = drawer.querySelector('[data-sv7-drawer-upsell-scroll]');
var elUpsellTitle = drawer.querySelector('[data-sv7-drawer-upsell-title]');
var upsellPool = [];
try { upsellPool = JSON.parse(drawer.getAttribute('data-sv7-upsell-pool') || '[]'); } catch(_) { upsellPool = []; }
var soldMap = {};
try { soldMap = JSON.parse(drawer.getAttribute('data-sv7-sold-map') || '{}'); } catch(_) { soldMap = {}; }
var upsellTitleText = drawer.getAttribute('data-sv7-upsell-title') || 'Couples love these';
if (elUpsellTitle) elUpsellTitle.textContent = upsellTitleText;
var toastQueue = [];
var toastBusy = false;
function showToast(msg, ms){
if (!elToast) return;
toastQueue.push({ msg: msg, ms: ms || 2400 });
drainToast();
}
function drainToast(){
if (toastBusy || !toastQueue.length) return;
var next = toastQueue.shift();
toastBusy = true;
elToast.textContent = next.msg;
elToast.classList.add('is-show');
setTimeout(function(){
elToast.classList.remove('is-show');
setTimeout(function(){
toastBusy = false;
drainToast();
}, 360);
}, next.ms);
}
function fmt(paise){
var n = Math.round((paise|0)/100);
try { return '\u20B9' + n.toLocaleString('en-IN'); } catch(_) { return '\u20B9' + n; }
}
function escapeHtml(s){
return String(s == null ? '' : s)
.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
.replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function isGiftLine(item){
var marker = item && item.properties && item.properties._free_gift;
return marker === 'tier-1' || marker === 'tier-2' || marker === 'tier-3' ? marker : false;
}
var giftMembership = {}, offerMembership = {}, membershipRequests = {}, giftWork = null;
var giftRetryAfter = 0, giftOfferState = null;
try { giftMembership = JSON.parse(drawer.getAttribute('data-sv7-gift-membership') || '{}'); } catch (_) {}
function loadProductMembership(item) {
var pid = String(item.product_id || '');
if (!pid || membershipRequests[pid] || (typeof giftMembership[pid] === 'boolean' && Object.prototype.hasOwnProperty.call(offerMembership, pid))) return;
membershipRequests[pid] = true;
var handle = String(item.handle || '');
if (!handle) { giftMembership[pid] = null; offerMembership[pid] = null; membershipRequests[pid] = false; return; }
fetch('/products/' + encodeURIComponent(handle) + '?view=sv7-gift-eligibility', { credentials: 'same-origin' })
.then(function (r) { if (!r.ok) throw new Error('Offer eligibility unavailable'); return r.json(); })
.then(function (data) {
  if (String(data.product_id) !== pid || typeof data.eligible !== 'boolean' || typeof data.tarang !== 'boolean') throw new Error('Invalid offer eligibility');
  giftMembership[pid] = data.eligible;
  offerMembership[pid] = { tarang: data.tarang };
})
.catch(function () { giftMembership[pid] = null; offerMembership[pid] = null; })
.then(function () { membershipRequests[pid] = false; hydrate(window.sv7.cart.get()); });
}
function qualifyingSpend(state) {
var result = { subtotal: 0, pending: false, failed: false };
(state.items || []).forEach(function (item) {
if (isGiftLine(item) || item.handle === 'scratch-n-spice-date-night-position-card') return;
var pid = String(item.product_id || '');
if (!Object.prototype.hasOwnProperty.call(giftMembership, pid)) loadProductMembership(item);
// Gift tiers use merchandise before automatic discounts; complimentary items never qualify.
if (giftMembership[pid] === true) result.subtotal += Number(item.original_line_price != null ? item.original_line_price : item.line_price) || 0;
else if (giftMembership[pid] === null) result.failed = true;
else if (typeof giftMembership[pid] !== 'boolean') result.pending = true;
});
return result;
}
function automaticOfferApplied(state) {
var applied = false;
(state.items || []).forEach(function (item) {
  var allocations = item.line_level_discount_allocations || [];
  allocations.forEach(function (allocation) {
    var title = String((allocation.discount_application && allocation.discount_application.title) || allocation.title || '');
    if (/tarang|bogo/i.test(title)) applied = true;
  });
});
return applied;
}
function paintOfferState(state) {
var tarangQty = 0, pending = false;
(state.items || []).forEach(function (item) {
  if (isGiftLine(item)) return;
  var pid = String(item.product_id || '');
  if (!Object.prototype.hasOwnProperty.call(offerMembership, pid)) { loadProductMembership(item); pending = true; return; }
  var membership = offerMembership[pid];
  if (!membership) return;
  if (membership.tarang) tarangQty += Number(item.quantity || 0);
});
if (elOfferStatus) {
  if (automaticOfferApplied(state)) { elOfferStatus.textContent = 'Offer applied — your automatic saving is in the bag.'; elOfferStatus.hidden = false; }
  else { elOfferStatus.hidden = true; elOfferStatus.textContent = ''; }
}
if (!elNudge) return;
if (pending) { elNudge.hidden = true; return; }
var nudges = [];
if (tarangQty % 2 === 1) nudges.push('Complete the BOGO: add one more bodystocking and the cheaper one goes FREE.');
if (nudges.length) { elNudge.textContent = nudges.join(' '); elNudge.hidden = false; }
else { elNudge.hidden = true; elNudge.textContent = ''; }
}
function publishGiftOffer(state) {
var eligibility = qualifyingSpend(state);
var freeVariants = {};
(state.items || []).forEach(function (item) {
if (Number(item.final_line_price) === 0) freeVariants[String(item.variant_id || item.id)] = true;
});
giftOfferState = { subtotal: eligibility.subtotal, threshold: tier1, pending: eligibility.pending,
failed: eligibility.failed || Date.now() < giftRetryAfter,
confirmed: !!(freeVariants[tier1Variant] && freeVariants[tier2Variant] && freeVariants[tier3Variant]),
empty: !(state.items || []).length };
try { document.dispatchEvent(new CustomEvent('sv7:gifts:updated', { detail: giftOfferState })); } catch (_) {}
return eligibility;
}
window.sv7.giftOffer = {
get: function () { return giftOfferState; },
settle: function () {
var deadline = Date.now() + 3000;
return new Promise(function (resolve) {
function check() {
if ((!giftWork && !(giftOfferState && giftOfferState.pending)) || Date.now() >= deadline) { resolve(); return; }
setTimeout(check, 50);
}
check();
}).then(function () { return window.sv7.cart.refresh(); });
}
};
function subtotalExclGifts(state){
if (!state || !state.items) return 0;
var t = 0;
for (var i = 0; i < state.items.length; i++){
var it = state.items[i];
if (isGiftLine(it)) continue;
var lp = it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
t += lp;
}
return t;
}
function paintShippingTier(total){
if (!elShippingTier || !elShippingCopy) return;
var qualifiedTotal = Number(total) || 0;
var unlocked = qualifiedTotal >= shippingThreshold;
elShippingTier.setAttribute('data-unlocked', unlocked ? '1' : '0');
var shippingProgress = Math.max(0, Math.min(100, Number(((qualifiedTotal / shippingThreshold) * 100).toFixed(1))));
if (elShippingFill) elShippingFill.style.width = shippingProgress + '%';
if (elShippingProgress) elShippingProgress.setAttribute('aria-valuenow', String(Math.min(Math.floor(qualifiedTotal / 100), Math.floor(shippingThreshold / 100))));
if (unlocked) {
elShippingCopy.textContent = 'Free shipping unlocked — you save ₹99.';
return;
}
elShippingCopy.innerHTML = 'Add <strong>' + fmt(shippingThreshold - qualifiedTotal) + '</strong> more to save ₹99 on shipping.';
}
var prevReached = { t1: false, t2: false, t3: false };
function flashNode(el){
if (!el) return;
el.setAttribute('data-just-reached', '1');
setTimeout(function(){ el.removeAttribute('data-just-reached'); }, 1700);
}
function paintRewards(total){
var pctToMax = total >= tier3 ? 100 : Math.max(0, Math.round((total / tier3) * 100));
if (elRewardsFill) elRewardsFill.style.width = pctToMax + '%';
var reached1 = total >= tier1;
var reached2 = total >= tier2;
var reached3 = total >= tier3;
if (elNode1) elNode1.setAttribute('data-reached', reached1 ? '1' : '0');
if (elNode2) elNode2.setAttribute('data-reached', reached2 ? '1' : '0');
if (elNode3) elNode3.setAttribute('data-reached', reached3 ? '1' : '0');
if (reached1 && !prevReached.t1) flashNode(elNode1);
if (reached2 && !prevReached.t2) flashNode(elNode2);
if (reached3 && !prevReached.t3) flashNode(elNode3);
if (!reached3 && prevReached.t3)      showToast('\u26A0\uFE0F You just lost ' + tier3Label);
else if (!reached2 && prevReached.t2) showToast('\u26A0\uFE0F You just lost ' + tier2Label);
else if (!reached1 && prevReached.t1) showToast('\u26A0\uFE0F You just lost ' + tier1Label);
prevReached.t1 = reached1; prevReached.t2 = reached2; prevReached.t3 = reached3;
var nodes = [elNode1, elNode2, elNode3];
var reachedArr = [reached1, reached2, reached3];
var nextIdx = -1;
for (var ni = 0; ni < reachedArr.length; ni++) {
if (!reachedArr[ni]) { nextIdx = ni; break; }
}
for (var nj = 0; nj < nodes.length; nj++) {
if (!nodes[nj]) continue;
if (nj === nextIdx) nodes[nj].setAttribute('data-next', '1');
else nodes[nj].removeAttribute('data-next');
}
if (!elRewardsStatus) return;
var allUnlocked = reached3;
if (allUnlocked) {
var unlockedCopy = "You&rsquo;ve unlocked The Ishq Edit <span style=\"font-size:11px;letter-spacing:0.08em;text-transform:uppercase;font-weight:700;color:var(--sv7-red, #c7102d);margin-left:6px\">Morni included</span>";
elRewardsStatus.innerHTML = unlockedCopy;
elRewardsStatus.setAttribute('data-unlocked', 'all');
elRewardsStatus.removeAttribute('data-next-kind');
} else {
elRewardsStatus.removeAttribute('data-unlocked');
var gap, reward, statusCopy;
if (!reached1){
gap = tier1 - total;
reward = escapeHtml(tier1Label);
statusCopy = '<strong>' + fmt(gap) + '</strong> away from free ' + reward + '.';
}
else if (!reached2){ gap = tier2 - total; reward = escapeHtml(tier2Label); }
else { gap = tier3 - total; reward = escapeHtml(tier3Label); }
if (!statusCopy) {
  if (!reached2) reward = escapeHtml((tier2Label.split('+').pop() || tier2Label).trim());
  statusCopy = '<strong>' + fmt(gap) + '</strong> away from free ' + reward + '.';
}
elRewardsStatus.innerHTML = statusCopy;
elRewardsStatus.setAttribute('data-next-kind', 'gift');
}
}
function renderItem(item){
var gift = isGiftLine(item);
var flatlay = item.handle === 'shhh-it-s-secret-hour-satin-blindfold' || item.handle === 'elegant-restraint-game-satin-handcuffs';
var img = item.image || item.featured_image || '';
var imgUrl = '';
if (typeof img === 'string') imgUrl = img;
else if (img && img.url) imgUrl = img.url;
if (imgUrl && imgUrl.indexOf('http') !== 0 && imgUrl.indexOf('//') !== 0) imgUrl = '';
var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
var url = item.url || '#';
var title = item.product_title || item.title || '';
if (variant && title) {
var vLc = variant.toLowerCase();
var tLc = title.toLowerCase();
if (tLc.endsWith(' — ' + vLc) || tLc.endsWith(' - ' + vLc) || tLc.endsWith(' ' + vLc)) {
variant = '';
}
}
if (gift) title = title.replace(/^\uD83C\uDF81\s*/, '');
var lineP = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
var priceHtml = gift && lineP === 0
? '<span class="sv7-drawer__item-price sv7-drawer__item-price--free">Complimentary</span>'
: '<span class="sv7-drawer__item-price">' + fmt(lineP) + '</span>';
var qtyHtml = gift
? '<div class="sv7-drawer__item-qty sv7-drawer__item-qty--gift" aria-label="Gift quantity">' +
'<span class="sv7-drawer__item-qty-label">Qty ' + (item.quantity|0) + '</span>' +
'</div>'
: '<div class="sv7-drawer__item-qty" role="group" aria-label="Quantity">' +
'<button type="button" data-sv7-qty="dec" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' data-remove="1"' : '') + '>\u2212</button>' +
'<span class="sv7-drawer__item-qty-value" data-sv7-qty-value aria-live="polite">' + (item.quantity|0) + '</span>' +
'<button type="button" data-sv7-qty="inc" aria-label="Increase quantity">+</button>' +
'</div>';
var swapLinkHtml = '';
var invSlotHtml = (!gift)
? '<div class="sv7-drawer__item-invslot" data-sv7-inv-slot data-sv7-variant-id="' + escapeHtml(String(item.variant_id || '')) + '" data-sv7-handle="' + escapeHtml(item.handle || '') + '" data-sv7-key="' + escapeHtml(item.key) + '"></div>'
: '';
return '<li class="sv7-drawer__item' + (gift ? ' sv7-drawer__item--gift' : '') + '" data-key="' + escapeHtml(item.key) + '">' +
'<a class="sv7-drawer__item-media' + (flatlay ? ' sv7-drawer__item-media--flatlay' : '') + '" href="' + (gift ? '#' : escapeHtml(url)) + '" aria-hidden="true" tabindex="-1">' +
(imgUrl ? '<img loading="lazy" decoding="async" src="' + escapeHtml(imgUrl) + '" alt="" width="60" height="80">' : '') +
'</a>' +
'<div class="sv7-drawer__item-main">' +
(gift
? '<span class="sv7-drawer__item-title">' + escapeHtml(title) + '</span>'
: '<a class="sv7-drawer__item-title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>') +
(variant ? '<span class="sv7-drawer__item-variant">' + escapeHtml(variant) + '</span>' : '') +
(function(){ var _sd = item.product_id != null ? soldMap[String(item.product_id)] : null; return _sd ? '<span class="sv7-drawer__item-sold">' + escapeHtml(_sd) + ' sold</span>' : ''; })() +
priceHtml +
qtyHtml +
invSlotHtml +
swapLinkHtml +
'</div>' +
'<div class="sv7-drawer__item-side">' +
(gift
? ''
: '<button type="button" class="sv7-drawer__item-remove" data-sv7-remove="1" aria-label="Remove ' + escapeHtml(item.product_title || '') + '">\u00d7</button>') +
'</div>' +
'</li>';
}
var __sv7InvCache = {};   // handle → Map<variant_id, variant_data>
var __sv7InvInflight = {}; // handle → Promise
function fetchHandleInv(handle) {
if (!handle) return Promise.resolve(null);
if (__sv7InvCache[handle]) return Promise.resolve(__sv7InvCache[handle]);
if (__sv7InvInflight[handle]) return __sv7InvInflight[handle];
var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
.then(function(r){ return r.ok ? r.json() : null; })
.then(function(data){
if (!data || !Array.isArray(data.variants)) return null;
var m = {};
for (var i = 0; i < data.variants.length; i++) {
var v = data.variants[i];
if (v && v.id) m[String(v.id)] = v;
}
__sv7InvCache[handle] = m;
return m;
})
.catch(function(){ return null; })
.then(function(r){ delete __sv7InvInflight[handle]; return r; });
__sv7InvInflight[handle] = p;
return p;
}
function paintInvSlot(slot, qty) {
if (!slot) return;
if (qty == null) { slot.innerHTML = ''; return; }
if (qty >= 4) { slot.innerHTML = ''; return; }
if (qty >= 1) {
slot.innerHTML = '<span class="sv7-drawer__item-stocklow">\u23F3 Only ' + qty + ' left</span>';
return;
}
var line = elItems.querySelector('[data-key="' + (slot.getAttribute('data-sv7-key') || '') + '"]');
var titleEl = line ? line.querySelector('.sv7-drawer__item-title') : null;
var titleText = (titleEl && titleEl.textContent ? titleEl.textContent.trim() : 'this piece');
var msg = encodeURIComponent('Hi Maya — please notify me when ' + titleText + ' is back in stock. Thanks!');
slot.innerHTML =
'<a class="sv7-drawer__item-bis" href="https://wa.me/919082301197?text=' + msg + '"' +
' target="_blank" rel="noopener">' +
'\uD83D\uDD14 Out of stock \u00b7 Notify me' +
'</a>';
}
function decorateInventory() {
if (!elItems) return;
var slots = elItems.querySelectorAll('[data-sv7-inv-slot]');
for (var i = 0; i < slots.length; i++) (function(slot){
var handle = slot.getAttribute('data-sv7-handle') || '';
var variantId = slot.getAttribute('data-sv7-variant-id') || '';
if (!handle || !variantId) return;
fetchHandleInv(handle).then(function(m){
if (!m) return;
var v = m[variantId];
if (!v) return;
var q = (v.inventory_management === 'shopify' && typeof v.inventory_quantity === 'number')
? v.inventory_quantity
: null;
paintInvSlot(slot, q);
});
})(slots[i]);
}
var lastMarker = '';
function hydrate(state){
if (!state) state = window.sv7.cart.get() || { items: [], count: 0, total: 0 };
var items = state.items || [];
var total = state.total || 0;
publishGiftOffer(state);
if (!items.length){
elItems.hidden = true; elItems.innerHTML = '';
elEmpty.hidden = false;
elFooter.hidden = true;
renderUpsell();
if (elUpsell && upsellPool && upsellPool.length > 0) elUpsell.hidden = false;
elCount.textContent = '';
paintRewards(0);
paintShippingTier(0);
if (elNudge) elNudge.hidden = true;
if (elOfferStatus) elOfferStatus.hidden = true;
return;
}
elEmpty.hidden = true;
elItems.hidden = false;
elFooter.hidden = false;
renderUpsell();
syncUpsellWithCart(state);
if (elUpsell && upsellPool && upsellPool.length > 0) elUpsell.hidden = false;
var sorted = items.slice().sort(function(a, b){
var ga = isGiftLine(a) ? 1 : 0;
var gb = isGiftLine(b) ? 1 : 0;
return ga - gb;
});
var marker = state.count + ':' + sorted.map(function(i){ return i.key + 'x' + i.quantity + ':' + i.final_line_price; }).join('|');
if (marker !== lastMarker){
var html = '';
var giftHtml = '', giftCount = 0;
for (var i = 0; i < sorted.length; i++) {
  if (isGiftLine(sorted[i])) { giftHtml += renderItem(sorted[i]); giftCount += Number(sorted[i].quantity || 0); }
  else html += renderItem(sorted[i]);
}
if (giftCount) html += '<li class="sv7-cart-gift-group"><details><summary>Your complimentary gifts · ' + giftCount + '<span aria-hidden="true"> +</span></summary><ul>' + giftHtml + '</ul></details></li>';
elItems.innerHTML = html;
lastMarker = marker;
}
decorateInventory();
elSubtotal.textContent = fmt(total);
elCount.textContent = '(' + (state.count|0) + ')';
paintRewards(qualifyingSpend(state).subtotal);
paintShippingTier(subtotalExclGifts(state));
paintOfferState(state);
paintSavings(state);
reconcileGifts(state);
}
function paintSavings(state){
if (!elSavings || !elSavingsAmt) return;
var items = state.items || [];
var savings = 0;
for (var i = 0; i < items.length; i++){
var it = items[i];
if (isGiftLine(it)) continue;
var qty = it.quantity || 0;
var compareUnit = it.compare_at_price || 0;
var priceUnit = (it.final_price != null) ? it.final_price : (it.price || 0);
if (compareUnit > priceUnit && qty > 0){
savings += (compareUnit - priceUnit) * qty;
}
}
if (state.total_discount && state.total_discount > 0) savings += state.total_discount;
if (savings > 0){
elSavingsAmt.textContent = fmt(savings);
elSavings.hidden = false;
} else {
elSavings.hidden = true;
}
}
function giftPlan(state, eligibility) {
var plan = { changes: [], adds: [], chargedGift: false };
if (eligibility.pending || eligibility.failed) return plan;
var items = state.items || [];
var expected = { 'tier-1': tier1Variant, 'tier-2': tier2Variant, 'tier-3': tier3Variant };
// Remove stale legacy tiers and duplicates before adding the currently-earned gifts.
items.forEach(function (item) {
var marker = isGiftLine(item);
if (!marker) return;
var variant = String(item.variant_id || item.id);
if (!expected[marker] || expected[marker] !== variant || items.some(function (other) { return !isGiftLine(other) && String(other.variant_id || other.id) === variant; })) {
plan.changes.push({ key: item.key, quantity: 0 });
}
});
if (plan.changes.length) return plan;
[['tier-1', tier1Variant, tier1], ['tier-2', tier2Variant, tier2], ['tier-3', tier3Variant, tier3]].forEach(function (tier) {
var marked = items.filter(function (item) { return isGiftLine(item) === tier[0]; });
var hasRetail = items.some(function (item) { return !isGiftLine(item) && String(item.variant_id || item.id) === tier[1]; });
var eligible = !giftsDisabled && eligibility.subtotal >= tier[2];
marked.sort(function (a, b) { return Number(a.final_line_price || 0) - Number(b.final_line_price || 0); });
marked.forEach(function (item, index) {
if (!eligible || index > 0) plan.changes.push({ key: item.key, quantity: 0 });
else if (item.quantity > 1) plan.changes.push({ key: item.key, quantity: 1 });
else if (Number(item.final_line_price) > 0) { plan.changes.push({ key: item.key, quantity: 0 }); plan.chargedGift = true; }
});
if (eligible && tier[1] && !marked.length && !hasRetail && Date.now() >= giftRetryAfter) {
plan.adds.push({ id: Number(tier[1]), quantity: 1, properties: { _free_gift: tier[0] } });
}
});
return plan;
}
var giftCheckoutTimer = null;
function setGiftCheckoutSettling(active) {
if (giftCheckoutTimer) { clearTimeout(giftCheckoutTimer); giftCheckoutTimer = null; }
var buttons = document.querySelectorAll('[data-sv7-el="cart:checkout-gokwik"], [data-sv7-el="cart:checkout-native"], #sv7-cart-main-form button[name="checkout"]');
Array.prototype.forEach.call(buttons, function (button) {
if (active) {
if (button.getAttribute('data-sv7-cart-settling') !== '1') button.setAttribute('data-sv7-cart-was-disabled', button.disabled ? '1' : '0');
button.setAttribute('data-sv7-cart-settling', '1'); button.setAttribute('aria-busy', 'true'); button.disabled = true;
} else if (button.getAttribute('data-sv7-cart-settling') === '1') {
button.disabled = button.getAttribute('data-sv7-cart-was-disabled') === '1';
button.removeAttribute('data-sv7-cart-settling'); button.removeAttribute('data-sv7-cart-was-disabled'); button.removeAttribute('aria-busy');
}
});
// A delayed service must not permanently strand the shopper at checkout.
if (active) giftCheckoutTimer = setTimeout(function () { setGiftCheckoutSettling(false); }, 3000);
}
function reconcileGifts(state) {
if (giftWork) return;
var plan = giftPlan(state, qualifyingSpend(state));
if (!plan.changes.length && !plan.adds.length) return;
if (plan.chargedGift) giftRetryAfter = Date.now() + 60000;
setGiftCheckoutSettling(true);
giftWork = Promise.resolve();
plan.changes.forEach(function (change) { giftWork = giftWork.then(function () { return window.sv7.cart.change(change.key, change.quantity); }); });
if (plan.adds.length) giftWork = giftWork.then(function () { return window.sv7.cart.addItems(plan.adds); });
giftWork.catch(function (err) {
giftRetryAfter = Date.now() + 60000;
try { (window.__sv7Errors = window.__sv7Errors || []).push({ t: Date.now(), l: 'gift-reconcile', m: err.message || String(err) }); } catch (_) {}
}).then(function () { giftWork = null; setGiftCheckoutSettling(false); hydrate(window.sv7.cart.get()); });
}
var upsellRendered = false;
var upsellFetchAttempted = false;
function renderUpsellCard(p) {
if (!p || !p.v) return '';
var priceTxt = fmt(p.p || 0);
var cmpTxt = (p.c && p.c > p.p && p.c <= p.p * 2) ? ('<span class="sv7-drawer__upsell-compare">' + fmt(p.c) + '</span>') : '';
return '<article class="sv7-drawer__upsell-card" role="listitem" data-sv7-upsell-pid="' + escapeHtml(String(p.pid || '')) + '">' +
'<a class="sv7-drawer__upsell-img" href="/products/' + escapeHtml(p.h || '') + '" tabindex="-1" aria-hidden="true">' +
(p.img ? '<img loading="lazy" decoding="async" src="' + escapeHtml(p.img) + '" alt="" width="120" height="160">' : '') +
'</a>' +
'<div class="sv7-drawer__upsell-body">' +
'<span class="sv7-drawer__upsell-cardtitle">' + escapeHtml(p.t || '') + '</span>' +
(p.s ? '<span class="sv7-drawer__upsell-sold">' + escapeHtml(p.s) + ' sold</span>' : '') +
'<div class="sv7-drawer__upsell-priceline">' +
'<span class="sv7-drawer__upsell-price">' + priceTxt + '</span>' + cmpTxt +
'</div>' +
'<button type="button" class="sv7-drawer__upsell-add" data-sv7-upsell-add="' + escapeHtml(String(p.v)) + '" data-sv7-upsell-title="' + escapeHtml(p.t || '') + '" aria-label="Add ' + escapeHtml(p.t || '') + ' to cart">+ Add</button>' +
'</div>' +
'</article>';
}
function renderUpsellFromPool(pool, titlePrefix) {
if (!elUpsellScroll) return false;
if (!Array.isArray(pool) || pool.length === 0) return false;
var state = (window.sv7 && window.sv7.cart) ? window.sv7.cart.get() : null;
var cartProductIds = {};
if (state && Array.isArray(state.items)) {
for (var ci = 0; ci < state.items.length; ci++) {
var cartProductId = state.items[ci] && state.items[ci].product_id;
if (cartProductId) cartProductIds[String(cartProductId)] = true;
}
}
var html = '';
for (var i = 0; i < pool.length; i++) {
if (pool[i] && !cartProductIds[String(pool[i].pid || '')]) html += renderUpsellCard(pool[i]);
}
if (!html) return false;
elUpsellScroll.innerHTML = html;
if (elUpsellTitle && titlePrefix) elUpsellTitle.textContent = titlePrefix;
return true;
}
function syncUpsellWithCart(state) {
if (!elUpsellScroll || !state || !Array.isArray(state.items)) return;
var cartProductIds = {};
for (var i = 0; i < state.items.length; i++) {
var productId = state.items[i] && state.items[i].product_id;
if (productId) cartProductIds[String(productId)] = true;
}
var cards = elUpsellScroll.querySelectorAll('[data-sv7-upsell-pid]');
for (var j = 0; j < cards.length; j++) {
if (cartProductIds[cards[j].getAttribute('data-sv7-upsell-pid') || '']) cards[j].remove();
}
}
function pickAnchorItem() {
var state = (window.sv7 && window.sv7.cart) ? window.sv7.cart.get() : null;
if (!state || !Array.isArray(state.items) || state.items.length === 0) return null;
var anchor = null;
for (var i = 0; i < state.items.length; i++) {
var it = state.items[i];
if (isGiftLine(it)) continue;
if (!anchor) { anchor = it; continue; }
var aLp = anchor.final_line_price != null ? anchor.final_line_price : (anchor.line_price || 0);
var iLp = it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
if (iLp > aLp) anchor = it;
}
return anchor;
}
function renderUpsell(){
if (!elUpsellScroll || upsellRendered) return;
var placedStatic = renderUpsellFromPool(upsellPool, upsellTitleText);
upsellRendered = true;
if (placedStatic) return;   // curated 4-product pool is fixed — do NOT replace with copurchase recs
if (upsellFetchAttempted) return;
upsellFetchAttempted = true;
var anchor = pickAnchorItem();
if (!anchor || !anchor.product_id) {
if (!placedStatic && elUpsell) elUpsell.hidden = true;
return;
}
fetch('https://engage.sinderella.in/api/copurchase/' + String(anchor.product_id) + '?limit=6&enriched=1', { credentials: 'omit' })
.then(function(r){ return r.ok ? r.json() : null; })
.then(function(data){
if (!data || !Array.isArray(data.companions)) return;
var pool = [];
var resolves = [];
for (var i = 0; i < data.companions.length; i++) {
var c = data.companions[i];
if (!c || !c.handle || !c.image || !c.title) continue;
resolves.push(
fetch('/products/' + encodeURIComponent(c.handle) + '.js', { credentials: 'same-origin' })
.then(function(r){ return r.ok ? r.json() : null; })
.then((function(cc){ return function(pj){
if (!pj || !Array.isArray(pj.variants) || pj.variants.length === 0) return null;
var fv = pj.variants.find(function(x){ return x.available; }) || pj.variants[0];
if (!fv || !fv.id) return null;
return {
v: fv.id,
pid: cc.companion_id,
h: cc.handle,
t: cc.title,
p: Math.round(Number(fv.price) || 0),
c: (fv.compare_at_price && fv.compare_at_price > fv.price) ? Math.round(Number(fv.compare_at_price)) : 0,
img: cc.image,
};
}; })(c))
.catch(function(){ return null; })
);
}
return Promise.all(resolves);
})
.then(function(resolved){
if (!Array.isArray(resolved)) return;
var pool = resolved.filter(function(x){ return x && x.v; });
if (pool.length < 2) return;  
if (renderUpsellFromPool(pool, 'Couples also bought')) {
if (elUpsell) elUpsell.hidden = false;
}
})
.catch(function(){  });
}
if (elUpsellScroll){
elUpsellScroll.addEventListener('click', function(ev){
var btn = ev.target && ev.target.closest ? ev.target.closest('[data-sv7-upsell-add]') : null;
if (!btn || btn.disabled) return;
var vid = btn.getAttribute('data-sv7-upsell-add');
if (!vid) return;
btn.disabled = true;
btn.textContent = 'Adding…';
if (window.sv7 && window.sv7.cart && typeof window.sv7.cart.add === 'function') {
window.sv7.cart.add(parseInt(vid, 10), 1).then(function(){
btn.textContent = '✓ Added';
var addedCard = btn.closest ? btn.closest('.sv7-drawer__upsell-card') : null;
if (addedCard) addedCard.remove();
try { showToast('Added to cart'); } catch(_){}
setTimeout(function(){ btn.textContent = '+ Add'; btn.disabled = false; }, 1500);
}).catch(function(){
btn.textContent = '+ Add';
btn.disabled = false;
try { showToast('Could not add — try again'); } catch(_){}
});
} else {
btn.textContent = '+ Add';
btn.disabled = false;
}
});
}
if (elEmpty) {
elEmpty.addEventListener('click', function(ev){
var btn = ev.target && ev.target.closest ? ev.target.closest('[data-sv7-empty-pick-add]') : null;
if (!btn || btn.disabled) return;
var vid = btn.getAttribute('data-sv7-variant-id');
if (!vid) return;
btn.disabled = true;
if (window.sv7 && window.sv7.cart && typeof window.sv7.cart.add === 'function') {
window.sv7.cart.add(parseInt(vid, 10), 1).then(function(){
btn.classList.add('is-done');
btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
try { showToast('Added to cart'); } catch(_){}
setTimeout(function(){
btn.classList.remove('is-done');
btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
btn.disabled = false;
}, 1800);
}).catch(function(){
btn.disabled = false;
try { showToast('Could not add — try again'); } catch(_){}
});
} else {
btn.disabled = false;
}
});
}
var cartIdleTimer = null;
function armCartIdleTimer(state) {
if (cartIdleTimer) { clearTimeout(cartIdleTimer); cartIdleTimer = null; }
if (!state || !state.items || state.items.length === 0) return;
var phone = '';
try { phone = (localStorage.getItem('sv7:phone') || '').replace(/\D/g, ''); } catch(_){}
if (!phone || phone.length < 10) return;
cartIdleTimer = setTimeout(function(){
try {
var s = (window.sv7 && window.sv7.cart) ? window.sv7.cart.get() : null;
if (!s || !s.items || s.items.length === 0) return;
var top = null;
for (var i = 0; i < s.items.length; i++){
var it = s.items[i];
if (isGiftLine(it)) continue;
var lp = it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
if (!top || lp > (top.final_line_price || top.line_price || 0)) top = it;
}
if (!top) return;
var totalInr = Math.round((s.total || 0) / 100);
var payload = {
phone: phone,
topItemTitle: top.product_title || top.title || 'your piece',
topItemHandle: (top.handle || '').replace(/[^a-z0-9-]/gi, '').slice(0, 80).toLowerCase(),
topItemImage: (typeof top.image === 'string') ? top.image : (top.image && top.image.url) || '',
cartCount: s.count | 0,
cartTotalInr: totalInr
};
fetch('https://engage.sinderella.in/api/cart-abandonment/capture', {
method: 'POST',
credentials: 'omit',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify(payload),
keepalive: true
}).catch(function(){  });
} catch(_){}
}, 10 * 60 * 1000); // 10 minutes
}
window.sv7.cart.onChange(function(s){ hydrate(s); armCartIdleTimer(s); });
hydrate(window.sv7.cart.get());
window.sv7.cart.refresh();
var lastOpenRefresh = Date.now();
if (typeof MutationObserver === 'function'){
new MutationObserver(function(muts){
for (var i = 0; i < muts.length; i++){
if (muts[i].attributeName === 'open' && drawer.hasAttribute('open')){
if (Date.now() - lastOpenRefresh < 30000) break;
lastOpenRefresh = Date.now();
try { window.sv7.cart.refresh(); } catch(_){}
break;
}
}
}).observe(drawer, { attributes: true, attributeFilter: ['open'] });
}
drawer.addEventListener('click', function(e){
var li = e.target.closest && e.target.closest('.sv7-drawer__item');
if (!li || li.classList.contains('sv7-drawer__item--gift') || li.getAttribute('aria-busy') === 'true') return;
var key = li.getAttribute('data-key');
var btn = e.target.closest('button');
if (!key || !btn) return;
var currentQty = parseInt((li.querySelector('[data-sv7-qty-value]') || {}).textContent, 10) || 0;
var qtyAction = btn.getAttribute('data-sv7-qty');
var isRemove = btn.getAttribute('data-sv7-remove') === '1' || btn.getAttribute('data-remove') === '1';
if (!qtyAction && !isRemove) return;
var wanted = isRemove ? 0 : qtyAction === 'inc' ? currentQty + 1 : Math.max(1, currentQty - 1);
li.setAttribute('aria-busy', 'true');
Array.prototype.forEach.call(li.querySelectorAll('button'), function(button){ button.disabled = true; });
window.sv7.cart.update(key, wanted).then(function(newState){
if (qtyAction !== 'inc') return;
(newState.items || []).forEach(function(item){ if (item.key === key && item.quantity < wanted) showToast('Max available — only ' + item.quantity + ' in stock'); });
}).catch(function(err){ showToast((err && err.message) || 'Could not update cart — try again'); }).then(function(){
li.removeAttribute('aria-busy');
Array.prototype.forEach.call(li.querySelectorAll('button'), function(button){ button.disabled = false; });
});
});
drawer.addEventListener('click', function(e){
if (e.target === drawer){
window.sv7.closeDialog('sv7-cart-drawer');
}
});
function toggleInert(){
if (drawer.open) drawer.removeAttribute('inert');
else drawer.setAttribute('inert', '');
}
toggleInert();
drawer.addEventListener('close', function(){ toggleInert(); });
document.addEventListener('click', function(){ setTimeout(toggleInert, 0); });
} catch(e){
try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'cart-drawer-init',m:(e&&e.message)||String(e)});}catch(_){}
} }
if (document.readyState === 'loading'){
document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
init();
}
} catch(e){
try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'cart-drawer-outer',m:(e&&e.message)||String(e)});}catch(_){}
} })();
(function(){ if (window.__sv7SearchSuggestInit) return; window.__sv7SearchSuggestInit = true;
function init(){ try {
var dialog = document.getElementById('sv7-search');
if (!dialog) return;
var input   = dialog.querySelector('[data-sv7-search-input]');
var results = dialog.querySelector('[data-sv7-search-results]');
if (!input || !results) return;
var t = 0;
function debounce(fn, ms){
return function(){
var args = arguments, ctx = this;
clearTimeout(t);
t = setTimeout(function(){ fn.apply(ctx, args); }, ms);
};
}
function escapeHtml(s){
return String(s == null ? '' : s)
.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
.replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function render(products){
if (!products || !products.length) {
results.innerHTML = '<div class="sv7-search-dialog__empty" style="padding:8px 4px;color:#6b6b6b;font-size:13px;">No exact match — popular right now:</div><div style="display:flex;flex-wrap:wrap;gap:8px;padding:4px 4px 8px;">' + ['red teddy','bridal','handcuffs','babydoll','plus size','roleplay'].map(function(t){ return '<a href="/search?q=' + encodeURIComponent(t) + '&type=product" style="padding:6px 12px;border:1px solid #e5e2db;border-radius:999px;font-size:13px;color:#1a1a1a;text-decoration:none;white-space:nowrap;">' + escapeHtml(t) + '</a>'; }).join('') + '</div>';
return;
}
var html = products.slice(0, 8).map(function(p){
var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
var imgTag = img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="48" height="48">' : '';
return '<a href="' + escapeHtml(p.url) + '" class="sv7-search-dialog__result">'
+ imgTag
+ '<span class="sv7-search-dialog__result-title">' + escapeHtml(p.title) + '</span>'
+ (p.price ? '<span style="margin-left:auto;padding-left:8px;font-weight:600;white-space:nowrap;">₹' + escapeHtml(String(parseInt(p.price,10))) + '</span>' : '')
+ '</a>';
}).join('');
results.innerHTML = html;
}
function fetchSuggestions(q){
if (!q || q.length < 2) { results.innerHTML = ''; dialog.removeAttribute('data-has-query'); return; }
dialog.setAttribute('data-has-query', '1');
var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,body,product_type,tag,variants.title,vendor';
fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function(r){ return r.ok ? r.json() : null; })
.then(function(data){
if (!data || !data.resources || !data.resources.results) return;
render(data.resources.results.products || []);
})
.catch(function(){  });
}
input.addEventListener('input', debounce(function(){
var v = input.value.trim();
fetchSuggestions(v);
if (!v) { results.innerHTML = ''; dialog.removeAttribute('data-has-query'); }
}, 180));
var mo = new MutationObserver(function(){
if (dialog.open || dialog.hidden === false) {
setTimeout(function(){ try { input.focus(); } catch(_){} }, 50);
}
});
try { mo.observe(dialog, { attributes: true, attributeFilter: ['open','hidden'] }); } catch(_){}
// May 17 2026 — Gap G3: typeahead result clicks bypass form submit, so the
// user's typed search query (the only valid Search signal) was never recorded.
// 80-95% of search traffic goes through typeahead → PDP link click without
// ever hitting the form-submit listener. Fire sv7Track('Search') BEFORE
// navigation (click bubbles before browser follows link). Registered once
// inside init — sandbox-isolated, can't double-fire.
try {
results.addEventListener('click', function(ev){
var a = ev.target.closest('a.sv7-search-dialog__result');
if (!a) return;
try {
var q = (input.value || '').trim();
if (q && typeof window.sv7Track === 'function') {
window.sv7Track('Search', { search_string: q.slice(0, 200) });
}
} catch(_){}
});
} catch(_){}
} catch(e){
try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'search-suggest',m:(e&&e.message)||String(e)});}catch(_){}
} }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
})();
(function(){ if (window.__sv7SearchInit) return; window.__sv7SearchInit = true;
function init(){ try {
var dialog = document.getElementById('sv7-search');
if (!dialog) return;
var input   = dialog.querySelector('[data-sv7-search-input]');
var panel   = dialog.querySelector('[data-sv7-search-panel]');
var ghost   = dialog.querySelector('[data-sv7-search-ghost]');
var ghostQ  = dialog.querySelector('[data-sv7-search-ghost-q]');
if (!input || !panel) return;
var RECENT_KEY = 'sv7_search_recent';
var MAX_RECENT = 5;
function splitList(s) {
return String(s || '').split('|').map(function(x){ return x.trim(); }).filter(Boolean);
}
function escapeAttr(s){ return String(s).replace(/"/g, '&quot;'); }
function escapeHtml(s){
return String(s == null ? '' : s)
.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
.replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function renderChipRow(containerKey, queries) {
var row = panel.querySelector('[data-sv7-search-chips="' + containerKey + '"]');
if (!row) return;
row.innerHTML = queries.map(function(q, i){
return '<button type="button" class="sv7-search-panel__chip" data-sv7-search-q="' +
escapeAttr(q) + '"><span class="sv7-search-panel__chip-rank">' + (i + 1).toString().padStart(2, '0') +
'</span>' + escapeHtml(q) + '</button>';
}).join('');
}
var wkList  = splitList(panel.getAttribute('data-trend-week'));
var mnList  = splitList(panel.getAttribute('data-trend-month'));
var allList = splitList(panel.getAttribute('data-trend-all'));
renderChipRow('week',  wkList);
renderChipRow('month', mnList);
renderChipRow('all',   allList);
function loadRecent() {
try { var raw = localStorage.getItem(RECENT_KEY); return raw ? JSON.parse(raw) : []; }
catch (_) { return []; }
}
function saveRecent(list) {
try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT))); }
catch (_) {}
}
function pushRecent(q) {
q = String(q || '').trim(); if (!q) return;
var list = loadRecent().filter(function(x){ return x.toLowerCase() !== q.toLowerCase(); });
list.unshift(q);
saveRecent(list);
renderRecent();
}
function renderRecent() {
var wrap = panel.querySelector('[data-sv7-search-recent]');
var row  = panel.querySelector('[data-sv7-search-recent-chips]');
if (!wrap || !row) return;
var list = loadRecent();
if (!list.length) { wrap.hidden = true; return; }
wrap.hidden = false;
row.innerHTML = list.map(function(q){
return '<button type="button" class="sv7-search-panel__chip" data-sv7-search-q="' +
escapeAttr(q) + '">' + escapeHtml(q) + '</button>';
}).join('');
}
renderRecent();
var clearBtn = panel.querySelector('[data-sv7-search-recent-clear]');
if (clearBtn) {
clearBtn.addEventListener('click', function(){ saveRecent([]); renderRecent(); });
}
panel.addEventListener('click', function(ev){
var tab = ev.target.closest('[data-sv7-search-tab]');
if (tab) {
ev.preventDefault();
var key = tab.getAttribute('data-sv7-search-tab');
panel.querySelectorAll('[data-sv7-search-tab]').forEach(function(t){
var on = t.getAttribute('data-sv7-search-tab') === key;
t.classList.toggle('is-active', on);
t.setAttribute('aria-selected', on ? 'true' : 'false');
});
panel.querySelectorAll('[data-sv7-search-chips]').forEach(function(r){
r.hidden = r.getAttribute('data-sv7-search-chips') !== key;
});
return;
}
var chip = ev.target.closest('[data-sv7-search-q]');
if (chip) {
ev.preventDefault();
var q = chip.getAttribute('data-sv7-search-q') || '';
input.value = q;
pushRecent(q);
// May 17 2026 — Gap G2: chip click sets input.value + dispatches 'input'
// (triggers typeahead) but never submits the form, so the existing
// form-submit Search-fire was bypassed. Fire sv7Track('Search') here so
// trending-chip clicks are recorded as search intent.
try {
if (q && typeof window.sv7Track === 'function') {
window.sv7Track('Search', { search_string: q.slice(0, 200) });
}
} catch(_){}
input.dispatchEvent(new Event('input', { bubbles: true }));
try { input.focus(); } catch(_) {}
}
});
var form = dialog.querySelector('[data-sv7-search-form]');
if (form) {
form.addEventListener('submit', function(){
var q = (input.value || '').trim();
if (q) pushRecent(q);
});
}
var phrases = splitList(panel.getAttribute('data-typewriter'));
if (phrases.length > 0 && ghost && ghostQ) {
var idx = 0;
var mediaOK = true;
try { mediaOK = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch(_){}
ghostQ.textContent = phrases[0];
function updateGhostVisibility() {
if (input.value && input.value.length > 0) { ghost.style.display = 'none'; }
else { ghost.style.display = ''; }
}
updateGhostVisibility();
input.addEventListener('input', updateGhostVisibility);
function cycle() {
if (input.value && input.value.length > 0) return;
idx = (idx + 1) % phrases.length;
var next = function(){
ghostQ.textContent = phrases[idx];
ghost.classList.remove('is-hidden');
};
if (mediaOK) {
ghost.classList.add('is-hidden');
setTimeout(next, 240);
} else {
next();
}
}
setInterval(cycle, 2400);
}
} catch(e){
try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'search-panel',m:(e&&e.message)||String(e)});}catch(_){}
} }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
})();
(function(){ if (window.__sv7HeaderTrendInit) return; window.__sv7HeaderTrendInit = true;
function init(){ try {
var chip = document.querySelector('[data-sv7-trend]');
if (!chip) return;
var label = chip.querySelector('[data-sv7-trend-label]');
var raw = (chip.getAttribute('data-sv7-trend-queries') || '').split('|').map(function(s){ return s.trim(); }).filter(Boolean);
if (raw.length < 2 || !label) return;
var base = chip.getAttribute('href').replace(/([?&])q=[^&]*/, '$1q=__Q__');
if (base.indexOf('__Q__') < 0) { var sep = base.indexOf('?') < 0 ? '?' : '&'; base = base + sep + 'q=__Q__'; }
var i = 0;
var mediaOK = true;
try { mediaOK = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch(_){}
function swap(){
i = (i + 1) % raw.length;
var q = raw[i];
var next = function(){
label.textContent = q;
chip.setAttribute('href', base.replace('__Q__', encodeURIComponent(q)));
chip.setAttribute('aria-label', 'Trending: ' + q);
label.style.opacity = '1';
};
if (mediaOK) {
label.style.transition = 'opacity 200ms ease';
label.style.opacity = '0';
setTimeout(next, 220);
} else {
next();
}
}
setInterval(swap, 3000);
} catch(e){
try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'header-trend',m:(e&&e.message)||String(e)});}catch(_){}
} }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
})();

(function(){ if (window.__sv7DesktopSearchInit) return; window.__sv7DesktopSearchInit = true;
function init(){ try {
var form = document.querySelector('.sv7-header__search') || document.querySelector('[data-sv7-el="search:inline-form"]');
var input = form ? form.querySelector('input[type="search"]') : null;
var trigger = document.querySelector('[data-sv7-action="open"][data-sv7-target="sv7-search"]');
var dlg = document.getElementById('sv7-search');
if (!input || !dlg) return;
var openIt = function(e){
  try { if (dlg.open || dlg.hasAttribute('open')) return; } catch(_){}
  try { if (e) { e.preventDefault(); e.stopPropagation(); } } catch(_){}
  try { input.blur(); } catch(_){}
  try { if (typeof dlg.showModal === 'function') { dlg.showModal(); } else if (trigger) { trigger.click(); } } catch(_){ try { if (trigger) trigger.click(); } catch(__){} }
};
input.addEventListener('mousedown', function(e){ try { e.preventDefault(); } catch(_){} });
input.addEventListener('click', openIt);
input.addEventListener('focus', openIt);
} catch(e){ try{(window.__sv7Errors=window.__sv7Errors||[]).push({t:Date.now(),l:'desktop-search',m:(e&&e.message)||String(e)});}catch(_){} } }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
})();


/* Jul 6 refined-motion: below-fold scroll reveal. JS-additive — no JS, no hiding.
   PRM users + browsers without IO never get the classes. Transform/opacity only (no CLS). */
(function () {
  try {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sels = '.sv7home .sec-h,.sv7home .cat,.sv7home .edi,.sv7home .stats,.sv7home .promise,.sv7home .fn-news,.sv7home .card,.sv7pdp-rel-card,.sv7-cups__card';
    var els = Array.prototype.slice.call(document.querySelectorAll(sels)).filter(function (el) {
      return el.getBoundingClientRect().top > window.innerHeight * 0.92;
    });
    if (!els.length) return;
    document.documentElement.classList.add('sv7-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* reveal on intersection OR if already scrolled past (anchor jumps, bfcache restores) */
        if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('sv7-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el, i) {
      el.classList.add('sv7-reveal');
      el.style.transitionDelay = ((i % 3) * 60) + 'ms';
      io.observe(el);
    });
  } catch (e) { console.error('[sv7] reveal', e); }
})();
